export const getCTALink = (id: number) => {
  switch (id) {
    case 1:
      return `http://mixxo.com/product/project.html?cate_no=1098&utm_source=mbtitest&utm_medium=contents&utm_content=mbti_0323`;
    case 2:
      return `http://mixxo.com/product/project.html?cate_no=1119&utm_source=mbtitest&utm_medium=contents&utm_content=mbti_0323`;
    case 3:
      return `http://mixxo.com/product/project.html?cate_no=1120&utm_source=mbtitest&utm_medium=contents&utm_content=mbti_0323`;
    case 4:
      return `http://mixxo.com/product/project.html?cate_no=1121&utm_source=mbtitest&utm_medium=contents&utm_content=mbti_0323`;
    default:
      return "";
  }
};
